<div class="container">
  <form [formGroup]="stateForm" (ngSubmit)="onSubmit($event)" class="post">
    <div class="post">
      <div class="title">Book Appointment</div>
      <div class="form">
        <span class="input">
          <mat-form-field>
            <mat-label>Name</mat-label>
            <input formControlName="Title" matInput placeholder="" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Mobile No.</mat-label>
            <input
              [(ngModel)]="number"
              matInput
              placeholder=""
              [ngModelOptions]="{ standalone: true }"
            />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Title</mat-label>
            <input
              [(ngModel)]="title"
              matInput
              placeholder=""
              [ngModelOptions]="{ standalone: true }"
            />
          </mat-form-field>
        </span>

        <span class="input">
          <mat-form-field>
            <mat-label>No. Of Children</mat-label>
            <input
              [(ngModel)]="noOfChildren"
              matInput
              placeholder=""
              [ngModelOptions]="{ standalone: true }"
            />
          </mat-form-field>
        </span>

        <span class="input">
          <mat-form-field>
            <mat-label>Marital Status</mat-label>
            <input
              [(ngModel)]="maritalStatus"
              matInput
              placeholder=""
              [ngModelOptions]="{ standalone: true }"
            />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Date</mat-label>
            <input
              [(ngModel)]="DOB"
              matInput
              [matDatepicker]="picker4"
              [ngModelOptions]="{ standalone: true }"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker4"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker4></mat-datepicker>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Sex</mat-label>
            <input
              [(ngModel)]="sex"
              matInput
              placeholder=""
              [ngModelOptions]="{ standalone: true }"
            />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Address</mat-label>
            <input
              [(ngModel)]="address"
              matInput
              placeholder=""
              [ngModelOptions]="{ standalone: true }"
            />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Occupatiobn</mat-label>
            <input
              [(ngModel)]="occupatiobn"
              matInput
              placeholder=""
              [ngModelOptions]="{ standalone: true }"
            />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Comment</mat-label>
            <input
              [(ngModel)]="comment"
              matInput
              placeholder=""
              [ngModelOptions]="{ standalone: true }"
            />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Ref Dr.</mat-label>
            <input
              [(ngModel)]="refDrs"
              matInput
              placeholder=""
              [ngModelOptions]="{ standalone: true }"
            />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Date</mat-label>
            <input
              formControlName="ScheduleDate"
              matInput
              [matDatepicker]="picker3"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker3"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker3></mat-datepicker>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Time</mat-label>
            <input formControlName="ScheduleTime" matInput placeholder="" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Branch</mat-label>
            <mat-select
              formControlName="OnlineBranchId"
              matNativeControl
              required
            >
              <mat-option *ngFor="let branch of branches" [value]="branch.Id">{{
                branch.Name
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </span>

        <span class="input">
          <mat-form-field>
            <mat-label>Services</mat-label>
            <input
              [(ngModel)]="item"
              (ngModelChange)="refchg($event)"
              matInput
              [ngModelOptions]="{ standalone: true }"
              required
            />
            <div class="float" style="position: relative; width: 3px">
              <div class="ret" *ngIf="drVisible">
                <div
                  class="list"
                  (click)="addItem(item)"
                  *ngFor="let item of searchRef"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
          </mat-form-field>
        </span>
        <div class="table">
          <div
            class="service"
            (click)="deleteItem(item)"
            *ngFor="let item of opdPrice"
          >
            {{ item.name }}<br />
            <!-- {{item.name}} -->
          </div>
        </div>
      </div>
      <div
        class=""
        style="margin-bottom: 30px; display: flex; justify-content: center"
      >
        <button
          class="create"
          style="margin-top: 20px"
          type="submit"
          mat-raised-button
          color="primary"
          style="margin-left: 20px"
        >
          {{ isLoading ? "Saving..." : "Save" }}
        </button>
      </div>
    </div>
  </form>
</div>
